import useFullPageLoader from 'common/UseFullPageLoader';
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import { getMasterListApi } from 'services/masterApi';
import { ManageDeliverySlotsTabs } from 'utils/componentValue/MasterValue';
import DeliverySlots from './section/DeliverySlots';
import DeliveryFees from './section/DeliveryFees';
import FreeDelivery from './section/FreeDelivery';

const ManageDelivery = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [loader, onShow, onHide] = useFullPageLoader();
    const [manageDeliveryList, setManageDeliveryList] = useState([])
    const position = searchParams.get("position") || 'DELIVERYSLOTS';
    const slotType = searchParams.get("deliverySlot") || 'DELIVERY';
    // console.log('manageDeliveryList', manageDeliveryList)
    // console.log('position', position)

    // -------handle-tab-change------------------
    const handleTabChange = (tabValue) => {
        const newParams = new URLSearchParams(searchParams.toString());
        newParams.set("position", tabValue);
        setSearchParams(newParams);
    };

    // -------handle-tab-change------------------
    const handleSlotTabChange = (tabValue = 'one') => {
        const newParams = new URLSearchParams(searchParams.toString());
        newParams.set("deliverySlot", tabValue);
        setSearchParams(newParams);
    };
    // ---------get-list---------------
    const getsManageDeliverySlots = async () => {
        try {
            onShow();
            setManageDeliveryList([])
            const query = { type: position };
            if (position === 'DELIVERYSLOTS') {
                query.slotType = slotType; // or whatever value your API expects
            }
            const res = await getMasterListApi(query);
            const { code, data } = res?.data;
            if (code === 200) {
                setManageDeliveryList(data);
            }
        } catch (error) {
            console.log("delivery Data fetch error:---> ", error);
        } finally {
            onHide();
        }
    };

    useEffect(() => {
        getsManageDeliverySlots()
    }, [position, slotType])
    return (
        <div className="banner-management-parent">
            {loader}
            <div className="page_title">
                <h3>Manage Delivery Slots & Delivery Fees</h3>
            </div>
            <div className="card">
                {loader}
                <div className="tabContainer">
                    <ul>
                        {ManageDeliverySlotsTabs.map((tabData) => (
                            <li
                                key={tabData.id}
                                className={tabData.value === position ? "active" : "un-active"}
                                onClick={() => handleTabChange(tabData.value)}
                            >
                                {tabData.name}
                            </li>
                        ))}
                    </ul>
                </div>

                {/* ---------delivery-slot---------- */}
                {position === 'DELIVERYSLOTS' && <DeliverySlots {...{ manageDeliveryList, setManageDeliveryList, onHide, getsManageDeliverySlots, slotType, handleSlotTabChange }} />}
                {/* ---------delivery-fees---------- */}
                {position === 'DELIVERYFEES' && <DeliveryFees {...{ manageDeliveryList, setManageDeliveryList, onHide, getsManageDeliverySlots }} />}
                {/* ----------free-delivery--------- */}
                {position === 'FREEDELIVERY' && <FreeDelivery {...{ manageDeliveryList, setManageDeliveryList, onHide, getsManageDeliverySlots }} />}

            </div>
        </div>
    )
}

export default ManageDelivery